/** Тип документа. */
export enum TemplateDocumentType {
    /** Документ филиала. */
    OfficeGeneral = "office-general",

    /** Документ магазина. */
    ShopDocument = "shop-general",
}
